/**
 * RecordCategoriesSettingsTab — Ustawienia → „Kategorie" (wspólny panel).
 *
 * Jedno miejsce zarządzania NOWĄ osią klasyfikacji „Kategoria" (`record_categories`,
 * migracja 0123) dla wszystkich kartotek, które ją mają — podzielone per kartoteka
 * selektorem zakładek. Zastępuje wcześniejszą zakładkę „Kategorie" schowaną w hubie
 * ustawień modułu kontrahenta (decyzja właściciela 2026-08-27, patrz ADR).
 *
 * Lista kartotek: `RECORD_CATEGORY_KARTOTEKI` (`@/lib/record-categories`). Każda zakładka
 * renderuje generyczny `RecordCategoriesTab` sterowany wyłącznie `kartotekaKey` — pełny CRUD
 * listy dla danej kartoteki. Dziś: kontrahenci i dokumenty.
 *
 * Widoczność pozycji menu bramkowana w `Settings.tsx` (`crm_core.system_modules.manage` +
 * super-user) — to samo uprawnienie, które backend egzekwuje na mutacjach `/record-categories`.
 */

import { useTranslation } from 'react-i18next';

import { Tabs, type TabsItem } from '@/components/Tabs';
import { RECORD_CATEGORY_KARTOTEKI } from '@/lib/record-categories';

import { RecordCategoriesTab } from './RecordCategoriesTab';

export function RecordCategoriesSettingsTab() {
  const { t } = useTranslation();

  const items: TabsItem[] = RECORD_CATEGORY_KARTOTEKI.map((k) => ({
    value: k.kartotekaKey,
    label: t(k.labelKey),
    content: <RecordCategoriesTab kartotekaKey={k.kartotekaKey} />,
  }));

  return (
    <div data-testid="record-categories-settings">
      <Tabs items={items} idPrefix="record-categories-kartoteka" />
    </div>
  );
}
